
const NS = 'FocusMe'; // jshint ignore:line

export default function FocusMe($timeout, unregister) {
  "ngInject";

  return {
    link,
    restrict: 'A',
    scope: {
      trigger: '@focusMe'
    }
  };

  function link(scope, element) {
    const listeners = [];
    listeners.push(scope.$watch('trigger', focus));
    listeners.push(scope.$on('$destroy', () => unregister(listeners)));

    function focus(value) {
      if (value === 'true') {
        $timeout(function () {
          element[0].focus();
        }, 500);
      }
    }
  }
}
